var devBaseUrl = 'https://api-private.dev.atlassian.com';
var stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
var prodBaseUrl = 'https://api-private.atlassian.com';
export var BaseUrls = {
  dev: devBaseUrl,
  development: devBaseUrl,
  stg: stgBaseUrl,
  staging: stgBaseUrl,
  prd: prodBaseUrl,
  prod: prodBaseUrl,
  production: prodBaseUrl
};
export var getBaseUrl = function getBaseUrl(envKey, baseUrlOverride) {
  // The `custom` environment is used if the full resolver URL is provided by the user.
  // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
  if (envKey === 'custom') {
    return baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : prodBaseUrl;
  }

  // If an environment is provided, then use Stargate.
  if (envKey) {
    return envKey in BaseUrls ? BaseUrls[envKey] : prodBaseUrl;
  }
  return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
export var getResolverUrl = function getResolverUrl(envKey, baseUrlOverride) {
  // The `custom` environment is used if the full resolver URL is provided by the user.
  // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
  if (envKey === 'custom') {
    return baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : '/gateway/api/object-resolver';
  }

  // If an environment is provided, then use Stargate directly for requests.
  if (envKey || baseUrlOverride) {
    var baseUrl = baseUrlOverride || getBaseUrl(envKey);
    return "".concat(baseUrl, "/object-resolver");
  } else {
    // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
  }
};
export default BaseUrls;